import React from 'react';

import {ServerInformationProvider} from './serverInformationProvider.js'
import {EnvironmentGroupContextProvider} from './environmentGroupContextProvider.js'
import {InteractStatusContextProvider} from './interactStatusContextProvider.js'
import {CurrentDataContextProvider} from './currentDataContextProvider.js'
import {DebugContextProvider} from "./debugContextProvider.js"

export const InteractAdminAppContextProvider = ({ children }) => {
  return (
    <ServerInformationProvider>
      <EnvironmentGroupContextProvider>
        <InteractStatusContextProvider>
          <CurrentDataContextProvider>
            <DebugContextProvider>
              {children}
            </DebugContextProvider>
          </CurrentDataContextProvider>
        </InteractStatusContextProvider>
      </EnvironmentGroupContextProvider>
    </ServerInformationProvider>
  );
}